import {Parameter, Pdfa, ToolboxMergeMerge} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../helper/FunctionHelper";

export enum MergeOperation {
	atTheEnd = "atTheEnd",
	atTheBeginning = "atTheBeginning",
	afterPage = "afterPage",
	beforePage = "beforePage",
	replace = "replace"
}

export class PortalToolboxMergeMerge extends ToolboxMergeMerge implements Parameter {
	public operation?: MergeOperation;
	public archive?: boolean;
	public pdfa?: Pdfa;

	constructor(data: any) {
		super(data);

		this.operation = FunctionHelper.exists(data?.operation) ? data.operation : MergeOperation.atTheEnd;
		this.archive = FunctionHelper.exists(data?.archive) ? data.archive : false;
		this.pdfa = Pdfa.fromJson(data.pdfa);
	}

	public static getOperationDefault(): MergeOperation {
		return MergeOperation.atTheEnd;
	}

	public static getArchiveDefault(): boolean {
		return false;
	}

	public static fromJson(data: any): PortalToolboxMergeMerge {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		return new PortalToolboxMergeMerge(data);
	}

	public toJson(): any {
		return {
			...super.toJson(),
			'operation': this.operation,
			'archive': this.archive,
			'pdfa': this.pdfa?.toJson(),
		};
	}

	public clone(): PortalToolboxMergeMerge {
		return PortalToolboxMergeMerge.fromJson(this.toJson());
	}
}